<template>
  <div>
    <!-- <meta name="viewport" content="width=device-width,initial-scale=1.0" /> -->
    <sub-head subTitle="인증 / 수상 " subImg="award_top" class="web"></sub-head>
    <!-- <sub-head subTitle="인증 / 수상" class="mobile"></sub-head> -->
    <div class="page_padding">
      <bread-crumb :path="$route"></bread-crumb>
    </div>
    <div>
      <div class="page_padding">
        <div class="title-background">
          <p class="fontBold line-height3 word_break main-title font34">
            <span class="fontBold gray">혁신된 기술력으로 인증받은 </span>
            <span class="fontBold textOrange">"스마트 터치 테이블"</span>
          </p>
        </div>

        <div class="verticalSpacer-six"></div>
        <p class="font18 gray width70 marginAuto line-height2-5 word_break">
          4차 산업혁명 시대의 디지털 시너어 계층의 새로운 여가활동 및 인지능력
          향상을 제공하기 위해 뛰어난 기술력으로 혁신 콘텐츠를 개발하고 사용성
          효과성 검증을 통한 시니어전용 기능성 콘텐츠 및 시니어 헬스케어 시장
          개척에 앞장서기 위해 적극적인 노력을 기울이고 있습니다.
        </p>
      </div>
      <div class="page_padding item-container">
        <div class="item">
          <award-img
            title="아이템 검토"
            :isTitle="true"
            :ImgTitle="!isMobile ? 'award_img01' : 'm_award_img01'"
          >
            <template v-slot:content>
              <div class="verticalSpacer-3"></div>

              <ul class="ul-style">
                <li>아이템 검토 및 시제품 제작</li>
                <li>성남 헬스케어 전시 박람회 출품</li>
                <li>예산 사회 복지 박람회 출품</li>
                <li>
                  <p>
                    사용자 만족도 조사 평점 4.6
                    <span class="block line-height1-5">(3일/300명)</span>
                  </p>
                </li>
              </ul>
            </template>
          </award-img>
          <img
            class="img"
            src="@/assets/source/images/ic_awardarrow_right.png"
            alt="오른쪽화살표"
          />
        </div>
        <div class="item">
          <award-img
            title="시니어 연구"
            :isTitle="true"
            :ImgTitle="!isMobile ? 'award_img02' : 'm_award_img02'"
          >
            <template v-slot:content>
              <div class="verticalSpacer-3"></div>

              <ul class="ul-style">
                <li>
                  <p>
                    프로그램 운영을 통한 연구
                    <span class="block line-height1-5"
                      >(With 치매강사협회)</span
                    >
                  </p>
                </li>
                <li>
                  <p>
                    시니어 콘텐츠 및 UI/UX 연구
                    <span class="block line-height1-5">(With 경희대)</span>
                  </p>
                </li>
                <li>
                  시니어 UI/UX 연구
                </li>
                <li>
                  <p>
                    Weltech 사용성 연구
                    <span class="block line-height1-5"
                      >(강남대학교 미래복지 융합연구소)</span
                    >
                  </p>
                </li>
              </ul>
            </template>
          </award-img>
          <img
            class="img"
            src="@/assets/source/images/ic_awardarrow_right.png"
            alt="오른쪽화살표"
          />
        </div>
        <div class="item">
          <award-img
            title="기술 연구"
            :isTitle="true"
            :ImgTitle="!isMobile ? 'award_img03' : 'm_award_img03'"
          >
            <template v-slot:content>
              <div class="verticalSpacer-3"></div>

              <ul class="ul-style">
                <li class="word_break">
                  테이블형 인지 훈련 장치 관련 특허 5종 등록 3종 출원
                </li>
                <li>SW 저작권 8종 등록</li>
                <li>40여종 인지향상 콘텐츠 개발</li>
                <li>치매 선별 게임 콘텐츠 개발</li>
              </ul>
            </template>
          </award-img>
          <img
            class="img"
            src="@/assets/source/images/ic_awardarrow_right.png"
            alt="오른쪽화살표"
          />
        </div>
        <div class="item marginBottom40">
          <award-img
            title="시범 산업"
            :isTitle="true"
            :ImgTitle="!isMobile ? 'award_img04' : 'm_award_img04'"
          >
            <template v-slot:content>
              <div class="verticalSpacer-3"></div>

              <ul class="ul-style">
                <li class="word_break">
                  공기관, 민간기업, 학교 등 10여곳 기관에서 시범 사업 실시
                </li>
                <li>성남시니어 산업혁신 센터 시범 사업 참여</li>
                <li>강남대학교 Weltech 시범 사업 참여</li>
                <li>치매 선별 게임 콘텐츠 개발</li>
              </ul>
            </template>
          </award-img>
        </div>
      </div>
    </div>
    <div>
      <div class="page_padding">
        <div class="text-center">
          <div class="verticalSpacer-half"></div>
          <img
            src="@/assets/source/images/ic_awardarrow_down.png"
            alt="아래화살표"
          />
          <div class="ti-container">
            <div class="container-box">
              <div class="second-box">
                <div class="img-text">
                  <img
                    src="@/assets/source/images/ic_awardleaf.png"
                    alt="무늬"
                  />
                  <span class="ti-text">기술 등급 TI-4 획득</span>
                  <img
                    class="right-img"
                    src="@/assets/source/images/ic_awardleaf.png"
                    alt="무늬"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="background-award">
          <div class="page_padding">
            <section>
              <span class="award-item-title">해피테이블 수상</span>
              <div class="award-item-container">
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award01_01"
                  >
                    <template v-slot:content>
                      <span>중소벤처기업부 장관 표창장</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award01_02"
                  >
                    <template v-slot:content>
                      <span>중소벤처기업부 장관 표창장</span>
                    </template>
                  </award-img>
                </div>
              </div>
            </section>
            <section class="award-section">
              <span class="award-item-title mobileT">해피테이블 인증</span>
              <div class="award-item-container">
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award02_01"
                  >
                    <template v-slot:content>
                      <span>기술역량 우수기업(T4)</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award02_02"
                  >
                    <template v-slot:content>
                      <span>벤처기업확인서</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award02_03"
                  >
                    <template v-slot:content>
                      <span>소셜벤처기업인증</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award02_04"
                  >
                    <template v-slot:content>
                      <span>친고령혁신제품인증서</span>
                    </template>
                  </award-img>
                </div>
              </div>
            </section>
            <section class="award-section">
              <span class="award-item-title">사용성 및 효과성 평가</span>
              <div class="award-item-container">
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award03_01"
                  >
                    <template v-slot:content>
                      <span>Wel-Tech기반 사용성 평가</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award03_02"
                  >
                    <template v-slot:content>
                      <span>Wel-Tech기반 효과성 평가</span>
                    </template>
                  </award-img>
                </div>
              </div>
            </section>
            <section class="award-section">
              <span class="award-item-title">해피테이블 지적 재산권</span>
              <div class="award-item-container left">
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_01"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;치매예방 333놀이&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_02"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;치매예방 퀴즈풀이&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_03"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;색종이 가져오기&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_04"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;숫자 맞추기&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_05"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;테이블 축구&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_06"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;풍선 터트리기&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_07"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;같은 그림 찾기&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_08"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block">&#60;말 달리자&#62;</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_09"
                  >
                    <template v-slot:content>
                      <span>저작권 등록증</span>
                      <span class="textOrange block"
                        >&#60;해피테이블 컨텐츠&#62;</span
                      >
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_10"
                  >
                    <template v-slot:content>
                      <span>특허증</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_11"
                  >
                    <template v-slot:content>
                      <span>특허증</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_12"
                  >
                    <template v-slot:content>
                      <span>특허증</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_13"
                  >
                    <template v-slot:content>
                      <span>특허증</span>
                    </template>
                  </award-img>
                </div>

                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_14"
                  >
                    <template v-slot:content>
                      <span>특허증</span>
                    </template>
                  </award-img>
                </div>
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award04_15"
                  >
                    <template v-slot:content>
                      <span>특허증</span>
                    </template>
                  </award-img>
                </div>
              </div>
            </section>
            <section class="award-section">
              <span class="award-item-title">기타 성과</span>
              <div class="award-item-container">
                <div class="item award-item">
                  <award-img
                    :isTitle="false"
                    :is_jpg="false"
                    ImgTitle="award05_01"
                  >
                    <template v-slot:content>
                      <span>고령 친화 선도 기업 선정</span>
                    </template>
                  </award-img>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jsonContents from "../../assets/source/json/sub_top.json";
import cmsContents from "../../assets/source/json/happytable_cms.json";
import htContents from "../../assets/source/json/happytable_info.json";
import subHead from "../../components/sub_head.vue";

import BreadCrumb from "../../components/BreadCrumb.vue";
import AwardImg from "./AwardImg.vue";

export default {
  components: {subHead, BreadCrumb, AwardImg},
  data() {
    return {
      content: jsonContents,
      ht_info: htContents,
      cms_info: cmsContents,
      is_over: false,
      pic_index: 0,
      showModal: false,
      modalInfo: {
        is_jpg: true,
        name: "happytable_product2",
        path: "",
      },
      frameWidth: "700",
      frameHeight: "395",
      showGame: true,
      isMobile: false,
    };
  },
  created() {
    this.checkBrowserWidth();
    window.addEventListener("resize", this.checkBrowserWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkBrowserWidth);
  },
  methods: {
    getImgSrc(src, path) {
      var images;
      if (path == "") {
        src = "happytable_product" + (src + 2);
        images = require.context(
          "../../assets/source/images/",
          false,
          /\.jpg$/
        );
        return images("./" + src + ".jpg");
      } else if (path == "modal_product") {
        images = require.context(
          "../../assets/source/images/",
          false,
          /\.jpg$/
        );
        return images("./" + src + ".jpg");
      } else {
        images = require.context(
          "../../assets/source/images/screenshots",
          false,
          /\.jpg$/
        );
        return images("./" + src + ".jpg");
      }
    },
    getCMSImgSrc(src) {
      var images = require.context(
        "../../assets/source/images",
        false,
        /\.png$/
      );
      return images("./" + src + ".png");
    },
    is_mouseOver(index) {
      this.pic_index = index;
      this.is_over = true;
    },
    is_mouseDown(index) {
      this.pic_index = index;
      this.is_over = false;
    },
    product_detail(index) {
      this.showModal = true;
      this.modalInfo.name = "happytable_product" + (index + 2);
      document.querySelector("body").style.overflow = "hidden";
      return this.modalInfo;
    },

    closeModal() {
      this.showModal = false;
      document.querySelector("body").style.overflowY = "scroll";
    },
    checkBrowserWidth() {
      // if (window.innerWidth <= 767) {
      //   this.isMobile = true;
      // } else {
      //   this.isMobile = false;
      // }
    },
    // handleResize() {
    //   if (matchMedia("(min-width: 1701px)").matches) {
    //     this.frameWidth = "700";
    //     this.frameHeight = "395";
    //   } else if (
    //     matchMedia("(min-width: 1024px) and (max-width: 1279px)").matches
    //   ) {
    //     this.frameWidth = "380";
    //     this.frameHeight = "220";
    //   } else if (
    //     matchMedia("(min-width: 768px) and (max-width: 919px)").matches
    //   ) {
    //     this.frameWidth = "250";
    //     this.frameHeight = "150";
    //   } else if (
    //     matchMedia("(min-width: 920px) and (max-width: 1023px)").matches
    //   ) {
    //     this.frameWidth = "320";
    //     this.frameHeight = "190";
    //   } else if (
    //     matchMedia("(min-width:1281px) and (max-width:1500px)").matches
    //   ) {
    //     this.frameWidth = "500";
    //     this.frameHeight = "300";
    //   } else if (
    //     matchMedia("(min-width:1501px) and (max-width:1700px)").matches
    //   ) {
    //     this.frameWidth = "600";
    //     this.frameHeight = "350";
    //   }
    //   if (matchMedia("(max-width:767px)").matches) {
    //     this.showGame = false;
    //   } else {
    //     this.showGame = true;
    //   }
    // },
    // show_game() {
    //   navigator.sayswho = (function() {
    //     var ua = navigator.userAgent,
    //       tem,
    //       M =
    //         ua.match(
    //           /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    //         ) || [];
    //     if (/trident/i.test(M[1])) {
    //       tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    //       return "IE " + (tem[1] || "");
    //     }
    //     if (M[1] === "Chrome") {
    //       tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    //       if (tem != null)
    //         return tem
    //           .slice(1)
    //           .join(" ")
    //           .replace("OPR", "Opera");
    //     }
    //     M = M[2]
    //       ? [M[1], M[2]]
    //       : [navigator.appName, navigator.appVersion, "-?"];
    //     if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    //     return M.join(" ");
    //   })();

    //   if (
    //     navigator.sayswho == "IE 11" ||
    //     navigator.sayswho == "MSIE 10" ||
    //     navigator.sayswho == "MSIE 9" ||
    //     matchMedia("(max-width: 767px)").matches
    //   ) {
    //     this.showGame = false;
    //   }
    //   return this.showGame;
    // },
  },
};
</script>

<style scoped>
.mobile {
  display: none;
}
.marginTBAuto {
  margin: auto 0;
}
.paddingT {
  padding-top: 100px;
}

.block div.main_product_overlay {
  margin: 1rem;
}
.block div.main_product_overlay.pic2 {
  margin-left: 0;
}
.block div.main_product_overlay:last-child {
  margin-right: 0;
}
.block div img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.block .modal_img img {
  width: 100%;
  height: 100%;
  border-radius: 0px;
}
.d-flex-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.d-flex .right_text {
  padding: 0 3rem;
}
.d-flex-reverse .right_text {
  padding-right: 1rem;
}
.iconWrap {
  width: 150px;
  height: 150px;
}
.iconWrap img {
  width: 50%;
  height: 50%;
}

.cms_content {
  display: flex;
  flex-wrap: wrap;
}
.cms_content .d-flex {
  width: 50%;
}
/* .happytable_game {
  background-image: url("../../assets/source/images/happytable.png");
  background-repeat: no-repeat;
  padding: 1rem;
} */
.width100 img {
  width: 100%;
  border-radius: 10px;
}
.product_picture {
  /* background-image: url("../../assets/source/images/happytable_bg.jpg");
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat; */
  /* height: 480px; */
  /* height: 25vw; */
}
.overlay_wrap {
  width: 50px;
  height: 50px;
}
.overlay_icon_position {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.overlay_icon_position .overlay_flex {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.overlay_wrap {
  z-index: -1;
}

.is_on .overlay_wrap {
  z-index: 10;
}
.imgWrap img {
  width: 100%;
  height: 100%;
}
.edge {
  position: relative;
}

.iframe-wrapper {
  position: relative;
  background-color: #2b2e35;
  border-radius: 40px;
  padding: 7rem 0;
  width: 100%;
}
.iframe-wrapper .iframe {
  /* position: absolute; */
  width: 100%;
  height: 100%;
}

.imgWrap img {
  width: 100%;
  border-radius: 10px;
}
.experience_logo {
  position: absolute;
  bottom: 40px;
  left: 40px;
  /* width: 80px;
  height: 80px; */
}
.verticalSpacer-big {
  width: 100%;
  height: 10vw;
  margin: 0 auto;
}
.content-padding {
  padding: 3rem 0;
}
.margin_3 {
  margin: 3rem 0;
  padding: 2rem 0;
}
.info_img .imgWrap > img {
  border-radius: 10px !important;
}
.modal_img {
  height: 100%;
}
.modal_img.imgWrap img {
  border-radius: 0px;
  height: 100% !important;
}
.modal_imgWrap.imgWrap {
  height: 100%;
}
.modal_imgWrap.imgWrap img {
  height: 100%;
}
iframe {
  width: 700;
  height: 395;
}

.btn:hover {
  background-color: transparent;
  border-color: white;
}
a {
  text-decoration: none;
}
/* .game_more {
  height: 180px;
  background-image: url("../../assets/source/images/gamemore_bg.jpg");
} */

v::deep .title {
  width: 100%;
  border-radius: 49px;
  background-color: #ff5230;
  color: #fff;
  font-size: 1rem;
  padding: 0.9rem 0;
}

.main-title {
  margin-top: 7rem;
}

.ul-style {
  list-style: none;
  text-align: left;
}

.ul-style li {
  vertical-align: top;
  font-size: 0.9rem;
  display: flex;
  margin-bottom: 0.8rem;
  /* align-items: center; */
}

.ul-style li::before {
  content: "\2022";
  color: #8f8f8f;
  font-size: 30px;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  line-height: 0.6;
  margin-left: -0.4em;
}

.block {
  display: block;
  font-size: 13px;
  color: #ff8c75;
}
.item-container {
  display: flex;
  justify-content: space-between;
  margin-top: 6.5rem;
  flex-wrap: wrap;
}
.item {
  display: flex;
}

.img {
  width: 30px;
  height: 22px;
  margin: 0.9rem 1.2rem 0 2.8rem;
}

.ti-container {
  display: flex;
}

.container-box {
  width: 100%;
  background: #f6f6f6;
  border: 2px solid #c5c5c5;
  padding: 14px;
  margin: 2rem 0 11rem 0;
}

.second-box {
  border: 1px solid #e1e1e1;
  height: 8rem;
  display: grid;
  vertical-align: middle;
}

.img-text {
  align-items: center;
  display: flex;
  justify-content: center;
}

.ti-text {
  font-weight: bold;
  margin: 0 30px;
}

.img-text .right-img {
  transform: scaleX(-1);
}

.background-award {
  width: 100%;
  background: #f7f9fb;
  padding: 11rem 0 10rem 0;
}
.background-award img {
  background: none;
}
.ti-text {
  font-size: 33px;
  text-align: center;
}

.award-section {
  margin-top: 11rem;
}

.award-title {
  font-size: 40px;
  margin: 1rem 0;
}

.award-item-title {
  text-align: center;
  padding: 0 0 1rem 0;
  border-bottom: 2px solid #0a0a0a;
  font-size: 2.5rem;
  font-weight: bold;
}

.award-item-container {
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.left {
  justify-content: left;
}
.award-item {
  margin: 0 2.5rem;
}

@media (max-width: 1200px) {
  .item-container {
    margin-bottom: 2rem;
  }
  .item-container .item .img {
    display: none;
  }

  .mobileT {
    justify-content: left;
  }

  .award-item-title {
    font-size: 2rem;
  }
  /* .award-item .container .imgWrap >>> img {
    width: 90%;
  } */
}

@media (min-width: 1024px) and (max-width: 1280px) {
  .paddingT {
    padding-top: 80px;
  }
  /* .product_picture {
    height: 300px;
  } */
  .d-flex .right_text {
    padding: 0 1rem;
  }
  .content-padding {
    padding: 1rem 0;
  }
  .margin_3 {
    margin: 2rem 0;
    padding: 2rem 0;
  }
  iframe {
    width: 200;
    height: 150;
  }
  .game_more {
    height: 150px;
  }
  .iconWrap {
    width: 120px;
    height: 120px;
  }
  .block div.main_product_overlay {
    margin: 0.5rem;
  }
  .award-item-title {
    font-size: 1.8rem;
  }
  .item.award-item {
    max-width: calc(33% - 3.32%);
    width: 100%;
    margin: 0 1.66%;
  }
  .item.award-item >>> .container {
    width: 100%;
  }
  .award-item span.block {
    display: block;
  }
}

/* @media (max-width: 1023px) {
  .web {
    display: none;
  }
  .mobile {
    padding-top: 71px;
    display: block;
    height: 5rem;
  }
} */

@media (min-width: 768px) and (max-width: 1023px) {
  .paddingT {
    padding-top: 60px;
  }
  .content-padding {
    padding: 0.5rem 0;
  }
  .d-flex .right_text {
    padding: 0 1rem;
  }
  .iconWrap {
    width: 120px;
    height: 120px;
  }
  .cms_content {
    flex-direction: column;
  }
  .cms_content .d-flex {
    width: 100%;
  }
  .content_index {
    align-items: center;
  }
  .iframe-wrapper {
    padding: 5rem 0;
  }
  .experience_logo {
    position: absolute;
    bottom: 30px;
    left: 30px;
    width: 50px;
    height: 50px;
  }

  .experience_logo img {
    width: 100%;
  }
  .block div.main_product_overlay {
    margin: 0.5rem;
  }
  .game_more {
    height: 130px;
  }
  .game_more .btn .fontS {
    font-size: 1rem;
  }
  .item.award-item {
    max-width: calc(33% - 3.32%);
    margin: 0 1.66%;
  }
  .award-item span.block {
    display: block;
  }
}
@media (max-width: 767px) {
  .banner.web {
    margin-top: 60px;
    .banner-title {
      font-size: 1.52rem;
    }
  }

  .paddingT {
    padding-top: 60px;
  }
  .font41 {
    font-size: 30px;
  }
  .main-title {
    margin-top: 4rem;
  }
  .verticalSpacer-six {
    height: 30px;
  }
  .item-container {
    margin-top: 4rem;
  }
  .item {
    width: 100%;
    margin-bottom: 1rem;
  }

  .item .container {
    width: 100%;
  }
  span.block {
    display: inline;
  }
  .title {
    border-radius: 0px;
  }
  .item >>> .container .title {
    border-radius: 0px;
    margin-bottom: 0;
    padding: 1rem 0;
  }
  .verticalSpacer-3 {
    height: 15px;
  }
  .marginBottom18 {
    margin-bottom: 0;
  }
  p.width70 {
    width: 100%;
  }
  .happytable .d-flex,
  .happytable .d-flex-reverse {
    flex-direction: column;
  }
  .happytable .width60,
  .happytable .width40 {
    width: 100%;
    height: 100%;
  }
  .margin_3 {
    margin: 0.5rem 0;
    padding: 0.5rem 0;
  }
  .block div.main_product_overlay {
    margin: 0.2rem;
  }
  .block div.main_product_overlay.pic2 {
    margin-left: 0;
  }
  .block div.main_product_overlay:last-child {
    margin-right: 0;
  }
  .d-flex .right_text {
    padding: 0;
  }
  .content-padding {
    padding: 1.5rem 0;
  }
  .cms.d-flex {
    flex-direction: column;
  }
  .cms .width40,
  .cms .width60 {
    width: 100%;
  }
  .cms_content {
    flex-direction: column;
  }
  .iconWrap {
    width: 120px;
    height: 120px;
  }

  .cms_content .d-flex {
    width: 100%;
  }
  .content_index {
    align-items: center;
  }
  /* .title {
    font-size: 34px;
  } */
  .title.line-height3 {
    line-height: 2.5rem;
  }
  .item.award-item {
    max-width: calc(33% - 3.32%);
    margin: 0 1.66%;
  }
  .award-item span.block[data-v-4eae6014] {
    display: block;
  }
  .background-award {
    padding: 5rem 0;
  }
  .ti-text {
    font-size: 25px;
    margin: 0;
  }
  .award-item-title {
    font-size: 25px;
  }
}

/* @media (min-width: 320px) and (max-width: 1023px) {
  .web {
    display: none;
  }
  .mobile {
    padding-top: 71px;
    display: block;
    height: 5rem;
  }
} */
@media (max-width: 500px) {
  .ti-container img {
    width: 20%;
  }
  .ti-text {
    font-size: 20px;
    margin: 0;
  }
  .main-title .gray {
    display: block;
  }
}
</style>
